'use client'

import cn from 'classnames'
import { useTranslations } from 'next-intl'
import React, { ReactNode, useCallback, useEffect, useRef } from 'react'
import { RoundCloseIcon } from '../Buttons/RoundCloseIcon'
import TrashCloseIcon from '../Buttons/TrashCloseIcon/TrashCloseIcon'
import classes from './styles.module.scss'

interface SearchInputProps {
  value?: string
  onChange: (event: React.FormEvent<HTMLInputElement>) => void
  onClear: () => void
  isMobile?: boolean
  icon?: ReactNode
  withClear?: boolean
  placeholder?: string
  withAutoFocus?: boolean
}

const SearchInput = ({
  value,
  onChange,
  onClear,
  isMobile,
  icon = null,
  withClear = true,
  placeholder = 'searchBar.placeholder',
  withAutoFocus = false,
}: SearchInputProps) => {
  const t = useTranslations()
  const searchInputRef = useRef<HTMLInputElement | null>(null)

  const onSearchAreaClick = useCallback(() => {
    searchInputRef?.current?.focus()
  }, [])

  useEffect(() => {
    if (withAutoFocus) {
      setTimeout(() => {
        searchInputRef.current?.focus()
      }, 100)
    }
    /*eslint-disable-next-line*/
  }, [])

  return (
    <div className={cn(classes.searchInputContainer, 'searchInput')}>
      <div className={classes.searchInputWrapper} onClick={onSearchAreaClick}>
        {icon}
        <input
          className={classes.searchInput}
          ref={searchInputRef}
          value={value}
          onChange={onChange}
          placeholder={t(placeholder)}
        />
      </div>
      {withClear && (
        <div
          className={`${
            isMobile ? classes.mobileCloseContainer : classes.closeContainer
          }`}
        >
          {value?.length && isMobile ? (
            <TrashCloseIcon isMobileSearch onClickHandler={onClear} />
          ) : !isMobile ? (
            <RoundCloseIcon onClickHandler={onClear} />
          ) : null}
        </div>
      )}
    </div>
  )
}

export default SearchInput
